import isNil from 'lodash-es/isNil'
import omitBy from 'lodash-es/omitBy'

// ref: https://stackoverflow.com/a/55185218
const removeNil = <T extends object>(params: T): Partial<T> => {
  return omitBy<T>(params, isNil)
}

export default removeNil
